// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2wlpD{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;margin-top:1rem;padding:1.35rem 1.5rem;color:#231815;background-color:#e0eeff;border-radius:.5rem}@media(max-width:1023px){._3dm3j{-ms-flex:100% 1;flex:100% 1}}.EAoZ2{margin-left:1rem}@media(max-width:1023px){.EAoZ2{margin-left:0;margin-top:1rem}}", ""]);
// Exports
exports.locals = {
	"rating": "_2wlpD",
	"ratingTitle": "_3dm3j",
	"ratingButton": "EAoZ2"
};
module.exports = exports;
